import { getBaseRawAttributes } from "./helper.js";
import pluralize from "pluralize";

export const defineModel =
  (sequelize, Sequelize, Version) => (modelName, modelAttributes, options) => {
    const Model = sequelize.define(
      pluralize(modelName),
      {
        ...getBaseRawAttributes(Sequelize),
        ...modelAttributes,
      },
      options
    );

    Model.Version = Version(Model);

    return Model;
  };
